export enum BookingItemType {
    Arrival = 0,
    Departure = 1,
    Any = 2,
}
